// Report status constants
export const REPORT_STATUS = {
  PENDING: 'pending',
  COMPLETED: 'completed'
} as const;

// Validation constants
export const SCORE_RANGE = {
  MIN: 0,
  MAX: 10
} as const;

export const VISUALIZATION_TYPES = ['donut', 'spider', 'bar', 'line', 'radar'] as const;

// Error messages
export const ERROR_MESSAGES = {
  REPORT_UNAVAILABLE: 'Report is not available yet. Please complete all evaluations first.',
  REPORT_GENERATING: 'Report is being generated. Please check back in a few minutes.',
  REPORT_IN_PROGRESS: 'Report generation is in progress. Please check back shortly.',
  INVALID_STRUCTURE: 'Invalid report data structure',
  MISSING_QUESTIONS: 'Invalid report data: questions array is missing',
  MISSING_FEEDBACK: 'Invalid report data: feedback comments are missing',
  MISSING_METADATA: 'Invalid report data: metadata is missing'
} as const;